const ITEMS = [
  "MESTRE",
  "PADOVA",
  "SANT'ANGELO DI PIOVE DI SACCO",
  "SEMPRE PIÙ VICINO",
  "ASSISTENZA DEDICATA",
  "APERTO ANCHE 24/7",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-slate-100 bg-white py-5"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-10 font-display text-sm font-semibold uppercase tracking-[0.3em] text-slate-400"
              >
                {item}
                <span className="h-1.5 w-1.5 rounded-full bg-brand" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
